import { PACKAGE_GM } from './constants';

const isCategoryGeneralMerch = (packageCategory) => packageCategory === PACKAGE_GM;

const mergeProductFulfillment = (product, productsData = []) => {
  const item = productsData.find((fulfillment) => {
    return fulfillment.itemId === product.itemId;
  });
  return {
    ...product,
    fulfillment: item?.fulfillment,
  };
};

const mergeProductHighlights = (product, productsData = []) => {
  const item = productsData.find((hightlight) => {
    return hightlight.itemId === product.itemId;
  });
  return {
    ...product,
    highlights: item?.details?.highlights
  };
};

const mergeProductQuantityLimit = (product, products) => {
  return {
    ...product,
    info: {
      ...product.info,
      quantityLimit: products
        .find((productData) => productData.itemId === product.itemId)?.info?.quantityLimit
    }
  };
};

const mergePackageAndFulfillmentAndHighlightsAndQuantityLimits = (packageData, productsData) => {
  const products = packageData?.packages?.[0]?.products || [];
  const productsWithFulfillment = products
    .map((product) => mergeProductFulfillment(product, productsData?.products))
    .map((product) => mergeProductHighlights(product, productsData?.products))
    .map((product) => mergeProductQuantityLimit(product, productsData?.products));

  return {
    packages: [{
      metadata: packageData?.packages[0].metadata,
      products: productsWithFulfillment
    }]
  };
};

const getOnlineInventory = (fulfillmentOptions) => {
  let inventory;
  if (fulfillmentOptions) {
    fulfillmentOptions.forEach((option) => {
      if (option.services) {
        option.services.forEach((service) => {
          if (service.locations) {
            service.locations.forEach((location) => {
              if (location.type === 'online') {
                inventory = location.inventory;
              }
            });
          }
        });
      }
    });
  }

  return inventory;
};
const getIsPickUpOrDelivery = (fulfillmentProducts) => {
  let isPickUp = false;
  let isDelivery = false;
  (fulfillmentProducts.fulfillment?.fulfillmentOptions || []).forEach((option) => {
    if (option?.type === 'pickup') {
      isPickUp = true;
    } else if (option?.type === 'delivery') {
      isDelivery = true;
    }
  });
  return {
    isPickUp,
    isDelivery
  };
};

const formatDate = (fullDate) => {
  if (!fullDate) { return null; }

  /**
   * Per MDN:
   * Date-only strings (e.g. "1970-01-01") are treated as UTC,
   * while date-time strings (e.g. "1970-01-01T12:00") are treated as local.
   *
   * We add one second to get the local time, otherwise with UTC we can return a day earlier than expected.
   */
  return new Intl.DateTimeFormat('en-US', { dateStyle: 'medium' }).format(new Date(fullDate + 'T00:00:01'));
};

const fulfillmentBackOrderedStatus = (product) => {
  const backOrdered = product?.fulfillment?.backordered;
  const backorderedShipDate = formatDate(product?.fulfillment?.backorderedShipDate);

  return {
    backOrdered: !!backOrdered,
    backorderedShipDate,
  };
};

const getFulfillmentInformationSummary = (fulfillmentProductsMap) => {
  const fulfillmentInformationSummary = [];
  if (fulfillmentProductsMap) {
    fulfillmentProductsMap.forEach((product) => {
      const isOutOfStock = product.isOutOfStock;
      const pickUpOrDelivery = getIsPickUpOrDelivery(product);
      const isPickUp = pickUpOrDelivery.isPickUp;
      const isDelivery = pickUpOrDelivery.isDelivery;

      fulfillmentInformationSummary.push({
        itemId: product.itemId,
        isPickUp,
        isDelivery,
        isOutOfStock
      });
    });
  }

  return fulfillmentInformationSummary;
};

const getSummaryAvailabilityInfo = (products, selectedProductIds) => {
  const availabilityInfo = getFulfillmentInformationSummary(products);
  let isOutOfStock = false;
  const unfulfillableItemIds = [];

  availabilityInfo.forEach((item) => {
    const isSelected = selectedProductIds.includes(item.itemId);
    if (item.isOutOfStock && isSelected) {
      isOutOfStock = true;
    }
    if ((item.isOutOfStock) && isSelected) {
      unfulfillableItemIds.push(item.itemId);
    }
  });

  return {
    isOutOfStock,
    unfulfillableItemIds,
  };

};

const getQuantityError = (fulfillmentLoaded, product, isSummary = false) => {
  if (fulfillmentLoaded) {
    if (product.selectedQty > product.availableQty) {
      if (isSummary) {
        return `Your store only has ${product.availableQty} in stock of ${product.identifiers.productLabel}.
      Please reduce the quantity to proceed.`;
      }
      return `There are only ${product.availableQty} in stock at this time`;
    } if (product.info.quantityLimit > 0 && product.selectedQty > product.info.quantityLimit) {
      if (isSummary) {
        return `There is a quantity limit of ${product.info.quantityLimit} on ${product.identifiers.productLabel}.
        Please reduce the quantity to proceed.`;
      }
      return `There is a quantity limit of ${product.info.quantityLimit} on this product`;
    }
  }
  return undefined;
};

export {
  isCategoryGeneralMerch,
  mergePackageAndFulfillmentAndHighlightsAndQuantityLimits,
  mergeProductFulfillment,
  getOnlineInventory,
  getIsPickUpOrDelivery,
  fulfillmentBackOrderedStatus,
  getFulfillmentInformationSummary,
  getSummaryAvailabilityInfo,
  getQuantityError
};
